
export const formatPrice = (price: number, decimals?: number) => {
    return price?.toFixed(decimals).replace(",", ".").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
  